if (location.pathname.indexOf('pages/contact-us') > -1) {
	let intervalIdAZS = setInterval(() => { 
		let submitBtnAZS = document.querySelector('.wizard__submit');
		console.log(submitBtnAZS)
		if (submitBtnAZS) {
			clearInterval(intervalIdAZS);
			submitBtnAZS.addEventListener('click', function() {
				const formEl = document.querySelector('.globo-form-app form');
			    const inputWrapEls = formEl.querySelectorAll('.globo-form-control');
				let ticketFormData = {
			    	subject:"",
			    	comment:{
			    		body:""
			    	},
			    },customFields = [],checkIsSend = true;
			    ticketFormData.subject = formEl.querySelector('.field-subject .flat-input').value
			    ticketFormData.comment.body = formEl.querySelector('.filed-issue-details .flat-input').value
			    if (isEmptyAZS(ticketFormData.subject) || isEmptyAZS(ticketFormData.comment.body)) {
			    	return
			    }
			    let inputEls = [];
			    inputWrapEls.forEach(function(el, index) {
			        let inputEl = getElementFieldIdAZS(el);
			        if (inputEl) {
			        	inputEls.push(inputEl);
			        }
			    });
			    
			    inputEls.forEach(function(item,index){
			    	let fieldCustom = {};
			    	fieldCustom.id = item.field_id
			        fieldCustom.value = item.field_element.value
			        if (isEmptyAZS(fieldCustom.value)) {
			        	checkIsSend = false
			        }
			        customFields.push(fieldCustom)
			    })
			    if (checkIsSend === false) {
			    	return
			    }
			   
			    ticketFormData.custom_fields = customFields
			    let files = formEl.querySelector('.field-attachment .flat-input').files
				const formData = new FormData();
				if (files && files.length > 0) {
					formData.append('file',files[0]);
				}
       			formData.append('ticket',JSON.stringify(ticketFormData));
			    createTicketsAZS(formData)
			   
			});
		}

		function createTicketsAZS(formData){
			const url = `https://test-ga4-shopify.ourmimi.top/create-ticket.php`;

			let ticketId = getLocalUserZendeskTicket()
			formData.append('ticket_id',ticketId);
			fetch(url, {
			  method: 'POST',
			  body: formData
			})
			.then(response => response.json())
			.then(data => {
				setLocalUserZendeskTicket(data)
			  console.log('Response:', data);
			})
			.catch(error => {
			  console.error('Error:', error);
			});
		}

		function isEmptyAZS(str) {
		    return !str || str.trim() === "";
		}

		function getElementFieldIdAZS(El){
			let classList = El.className.split(' ');
			let inputObj = {};
			classList.forEach(function(className,index){
				if(className.indexOf('field_id') > -1){
					let nameList = className.split('-');
					let fieldId = nameList.pop();
					inputObj.field_id = fieldId;
					inputObj.field_element = El.querySelector('.flat-input');
				}
			})
			if (inputObj.field_id) {
				return inputObj;
			}
			return '';

		}

		function setLocalUserZendeskTicket(resData){
			localStorage.setItem('azs_ticket_id',resData.ticket.id);
		}

		function getLocalUserZendeskTicket(){
			return localStorage.getItem('azs_ticket_id') || '';
		}
	}, 500);
}

